// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const hasGradient = "Media__hasGradient__0ML5C";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const ieFix = "Media__ieFix__uCim9";
export const image = "Media__image__+QNAd";
export const insightMediaMaxWidth = "var(--insight-media-max-width)";
export const isLoading = "Media__isLoading__crT9s";
export const media = "Media__media__Jh-mb";
export const medium = "500";
export const placeholder = "Media__placeholder__l7qSc";
export const playIcon = "Media__playIcon__OoZwk";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const spinnerContainer = "Media__spinnerContainer__7jHe-";
export const video = "Media__video__1ZSt2";
export const videoButton = "Media__videoButton__h0cLM";
export const videoThumbnail = "Media__videoThumbnail__fWNFY";